import { getICXPricingInUSD } from "api/icxPricingAPI";
import { replaceFloatValue } from "utils/replaceFloatValue";

export const FETCH_ICX__PRICING_REQUEST = "FETCH_ICX__PRICING_REQUEST";
export const FETCH_ICX_PRICING_RESPONSE = "FETCH_ICX_PRICING_RESPONSE";
export const FETCH_ICX_PRICING_ERROR = "ETCH_ICX_PRICING_ERROR";

const fetchICXSuccess = (data) => {
  return {
    type: FETCH_ICX_PRICING_RESPONSE,
    data: data,
  };
};

const fetchICXFail = (error) => {
  return {
    type: FETCH_ICX_PRICING_ERROR,
    error: error,
  };
};

export const fetchICXPricingData = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_ICX__PRICING_REQUEST });

      const response = await getICXPricingInUSD();

      dispatch(fetchICXSuccess(response.data.icon.usd));
    } catch (error) {
      dispatch(fetchICXFail(error));
    }
  };
};
